// Mangalfera Films — Portfolio data

export const BRAND = {
  name: "Mangalfera Films",
  gujaratiName: "મંગળ ફેરા ફિલ્મ્સ",
  owner: "Urvesh Thummar",
  tagline: "Cinematic Wedding Stories, Beautifully Told",
  city: "Ahmedabad",
  serviceArea: "Ahmedabad / Gujarat / India / Destination Weddings",
  phone: "7069096113",
  whatsapp: "917069096113",
  email: "mangalferaf@gmail.com",
  instagram: "https://www.instagram.com/mangalferafilms/",
  instagramHandle: "@mangalferafilms",
  whatsappMessage: "Hello Mangalfera Films, I want to enquire about wedding photography and films.",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1665960213508-48f07086d49c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85";

export const FEATURED_STORIES = [
  {
    slug: "aarav-nidhi",
    couple: "Aarav & Nidhi",
    location: "Ahmedabad, Gujarat",
    type: "Wedding",
    cover: "https://images.unsplash.com/photo-1722952934708-749c22eb2e58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
    story:
      "A soulful Gujarati wedding filled with family warmth, rituals, laughter, and timeless emotions.",
  },
  {
    slug: "rohan-kavya",
    couple: "Rohan & Kavya",
    location: "Udaipur, Rajasthan",
    type: "Destination Wedding",
    cover: "https://images.unsplash.com/photo-1599462616558-2b75fd26a283?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
    story:
      "A royal celebration of love, traditions, and cinematic frames captured across a beautiful destination setting.",
  },
  {
    slug: "meet-jinal",
    couple: "Meet & Jinal",
    location: "Surat, Gujarat",
    type: "Engagement",
    cover: "https://images.unsplash.com/photo-1735052712464-9d24b69be5f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBwcmUlMjB3ZWRkaW5nJTIwY291cGxlJTIwcm9tYW5jZXxlbnwwfHx8fDE3ODEyNjcwODd8MA&ixlib=rb-4.1.0&q=85",
    story:
      "A graceful engagement story with elegant portraits, candid smiles, and beautiful family moments.",
  },
];

const galleryPool = [
  "https://images.unsplash.com/photo-1722952934708-749c22eb2e58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1599462616558-2b75fd26a283?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYW5kYXB8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1708606811579-23b18fc48007?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYW5kYXB8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1756190564669-215843660e93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYW5kYXB8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1587271339318-2e78fdf79586?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB3ZWRkaW5nJTIwaGFsZGklMjBtZWhlbmRpfGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1505932794465-147d1f1b2c97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB3ZWRkaW5nJTIwaGFsZGklMjBtZWhlbmRpfGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1525135850648-b42365991054?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3ZWRkaW5nJTIwaGFsZGklMjBtZWhlbmRpfGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1719857646787-38c9c5f79312?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBwcmUlMjB3ZWRkaW5nJTIwcHJlJTIwd2VkZGluZyUyMGNvdXBsZSUyMHJvbWFuY2V8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1587271598589-3f91d0872f66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwaGFsZGklMjBtZWhlbmRpfGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1735052712464-9d24b69be5f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBwcmUlMjB3ZWRkaW5nJTIwY291cGxlJTIwcm9tYW5jZXxlbnwwfHx8fDE3ODEyNjcwODd8MA&ixlib=rb-4.1.0&q=85",
];

const makeGallery = (size = 24) =>
  Array.from({ length: size }, (_, i) => galleryPool[i % galleryPool.length]);

export const WEDDINGS = [
  {
    slug: "aarav-nidhi",
    couple: "Aarav & Nidhi",
    location: "Ahmedabad, Gujarat",
    type: "Wedding",
    cover: FEATURED_STORIES[0].cover,
    story: FEATURED_STORIES[0].story,
    fullStory:
      "A soulful Gujarati wedding in the heart of Ahmedabad — from the first haldi smile to the final mangal fera, every moment unfolded with grace. Aarav and Nidhi's families came together with rituals that felt both timeless and deeply personal.",
    gallery: makeGallery(28),
    videoUrl: "https://player.vimeo.com/video/76979871",
  },
  {
    slug: "rohan-kavya",
    couple: "Rohan & Kavya",
    location: "Udaipur, Rajasthan",
    type: "Destination Wedding",
    cover: FEATURED_STORIES[1].cover,
    story: FEATURED_STORIES[1].story,
    fullStory:
      "On the marble ghats of Udaipur, Rohan and Kavya's love story unfolded like a forgotten royal painting. Soft palace light, lakeside vows, and a baraat that danced through cobblestone lanes.",
    gallery: makeGallery(32),
    videoUrl: "https://player.vimeo.com/video/76979871",
  },
  {
    slug: "meet-jinal",
    couple: "Meet & Jinal",
    location: "Surat, Gujarat",
    type: "Engagement",
    cover: FEATURED_STORIES[2].cover,
    story: FEATURED_STORIES[2].story,
    fullStory:
      "An intimate engagement in Surat — soft pastels, sunlit portraits, and the quiet kind of love that needs no audience.",
    gallery: makeGallery(22),
    videoUrl: null,
  },
  {
    slug: "harsh-priya",
    couple: "Harsh & Priya",
    location: "Vadodara, Gujarat",
    type: "Wedding",
    cover: "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYW5kYXB8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
    story:
      "A heritage wedding in Vadodara wrapped in marigolds, royal corridors and heartfelt laughter.",
    fullStory:
      "Harsh and Priya chose Vadodara's heritage halls to host a celebration that felt like a storybook page. Marigold canopies, brass lamps, and an unhurried rhythm of rituals.",
    gallery: makeGallery(26),
    videoUrl: null,
  },
  {
    slug: "dhruv-riya",
    couple: "Dhruv & Riya",
    location: "Rajkot, Gujarat",
    type: "Wedding",
    cover: "https://images.unsplash.com/photo-1708606811579-23b18fc48007?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYW5kYXB8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
    story:
      "Rajkot's golden afternoon light, a mandap of jasmine, and a couple that smiled through every fera.",
    fullStory:
      "A warm Rajkot wedding where Dhruv and Riya stepped into forever surrounded by family songs, soft incense, and golden hour portraits.",
    gallery: makeGallery(30),
    videoUrl: null,
  },
  {
    slug: "karan-disha",
    couple: "Karan & Disha",
    location: "Goa, India",
    type: "Destination Wedding",
    cover: "https://images.unsplash.com/photo-1756190564669-215843660e93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYW5kYXB8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
    story:
      "A breezy beachside celebration with sunset feras and a barefoot baraat by the waves.",
    fullStory:
      "Karan and Disha brought their families together by the Arabian sea — open skies, candlelit dinners and a sangeet under the stars.",
    gallery: makeGallery(34),
    videoUrl: "https://player.vimeo.com/video/76979871",
  },
];

export const FILMS = [
  {
    couple: "Aarav & Nidhi",
    location: "Ahmedabad, Gujarat",
    thumbnail: FEATURED_STORIES[0].cover,
    url: "https://player.vimeo.com/video/76979871",
    length: "4:32",
  },
  {
    couple: "Rohan & Kavya",
    location: "Udaipur, Rajasthan",
    thumbnail: FEATURED_STORIES[1].cover,
    url: "https://player.vimeo.com/video/76979871",
    length: "5:18",
  },
  {
    couple: "Meet & Jinal",
    location: "Surat, Gujarat",
    thumbnail: FEATURED_STORIES[2].cover,
    url: "https://player.vimeo.com/video/76979871",
    length: "3:54",
  },
  {
    couple: "Karan & Disha",
    location: "Goa, India",
    thumbnail:
      "https://images.unsplash.com/photo-1756190564669-215843660e93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYW5kYXB8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
    url: "https://player.vimeo.com/video/76979871",
    length: "4:46",
  },
];

export const PRE_WEDDING_GALLERY = [
  "https://images.unsplash.com/photo-1735052712464-9d24b69be5f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBwcmUlMjB3ZWRkaW5nJTIwY291cGxlJTIwcm9tYW5jZXxlbnwwfHx8fDE3ODEyNjcwODd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1719857646787-38c9c5f79312?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBwcmUlMjB3ZWRkaW5nJTIwcHJlJTIwd2VkZGluZyUyMGNvdXBsZSUyMHJvbWFuY2V8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1587271598589-3f91d0872f66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwaGFsZGklMjBtZWhlbmRpfGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1722952934708-749c22eb2e58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1505932794465-147d1f1b2c97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB3ZWRkaW5nJTIwaGFsZGklMjBtZWhlbmRpfGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1525135850648-b42365991054?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3ZWRkaW5nJTIwaGFsZGklMjBtZWhlbmRpfGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1599462616558-2b75fd26a283?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc4MTI2NzA4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBtYW5kYXB8ZW58MHx8fHwxNzgxMjY3MDg3fDA&ixlib=rb-4.1.0&q=85",
];

export const INSTAGRAM_GRID = [
  galleryPool[0], galleryPool[2], galleryPool[5], galleryPool[8],
  galleryPool[1], galleryPool[6], galleryPool[3], galleryPool[10],
];

export const SERVICES = [
  "Wedding Photography",
  "Cinematic Wedding Films",
  "Pre-Wedding Shoot",
  "Engagement Coverage",
  "Haldi / Mehendi Coverage",
  "Reception Coverage",
  "Drone Coverage",
  "Traditional Photography",
  "Traditional Videography",
  "Album Design",
  "Same Day Edit",
  "Instagram Reels / Teaser",
];

export const WHY_US = [
  { num: "10+", label: "Years of Experience" },
  { num: "400+", label: "Weddings Captured" },
  { num: "30+", label: "Team Members" },
  { num: "∞", label: "Stories Told" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Mangalfera Films captured our wedding exactly the way we dreamed. Every photo feels emotional, natural, and timeless.",
    name: "Aarav & Nidhi",
    place: "Ahmedabad",
  },
  {
    quote:
      "The team was professional, friendly, and creative. Our wedding film made us relive the entire celebration beautifully.",
    name: "Rohan & Kavya",
    place: "Udaipur",
  },
  {
    quote:
      "From pre-wedding to wedding day, every moment was captured with so much care. Highly recommended for cinematic wedding photography.",
    name: "Meet & Jinal",
    place: "Surat",
  },
];

export const EVENT_TYPES = [
  "Wedding",
  "Pre-Wedding",
  "Engagement",
  "Haldi / Mehendi",
  "Reception",
  "Destination Wedding",
  "Other",
];
